import { Marker, Popup } from 'react-leaflet';
import { RESOURCES, getCategoryIcon, getResourceTypeLabel } from '../../../data/resources';
import { useUserStore } from '../../../store/userStore';
import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { ClusterGroup } from './ClusterGroup';

export const ResourceLayer = ({
  categories,
  resources = RESOURCES,
  selectedResourceId,
  onResourceSelect,
  autoOpenResourceId,
  kidMode = true
}) => {
  const incrementMapInteractions = useUserStore((state) => state.incrementMapInteractions);
  const markerRefs = useRef({});

  const filteredResources = resources.filter((r) => categories.includes(r.category));

  const createCustomIcon = (resource, isSelected) => {
    const emoji = getCategoryIcon(resource.type);
    const categoryClass = `resource-marker-${resource.category}`;
    const size = isSelected ? 52 : 44;

    return L.divIcon({
      html: `
        <div class="resource-marker-shell ${isSelected ? 'resource-marker-shell-selected' : ''}">
          <div class="resource-marker ${categoryClass} ${isSelected ? 'resource-marker-selected' : ''} ${kidMode ? 'resource-marker-kid' : ''}">
            ${emoji}
          </div>
          ${kidMode ? '<span class="resource-marker-sparkle">✨</span>' : ''}
        </div>
      `,
      className: 'resource-marker-wrapper',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2]
    });
  };

  useEffect(() => {
    if (!autoOpenResourceId) return;
    const marker = markerRefs.current[autoOpenResourceId];
    if (marker && marker.openPopup) {
      marker.openPopup();
    }
  }, [autoOpenResourceId]);

  return (
    <ClusterGroup
      chunkedLoading
      showCoverageOnHover={false}
      spiderfyOnMaxZoom
      maxClusterRadius={44}
    >
      {filteredResources.map((resource) => (
        <Marker
          key={resource.id}
          ref={(node) => {
            if (node) {
              markerRefs.current[resource.id] = node;
            }
          }}
          position={[resource.lat, resource.lng]}
          icon={createCustomIcon(resource, resource.id === selectedResourceId)}
          eventHandlers={{
            click: () => {
              incrementMapInteractions();
              onResourceSelect?.(resource);
            }
          }}
        >
          <Popup className="custom-popup kids-popup kids-popup-resource" maxWidth={320}>
            <div dir="rtl" className="kids-popup-body">
              <h3 className="kids-popup-title">
                <span>{getCategoryIcon(resource.type)}</span>
                {resource.name}
              </h3>
              <div className="kids-popup-media">
                {resource.images && resource.images.length > 0 && (
                  <img
                    src={resource.images[0]}
                    alt={resource.name}
                    className="w-full h-40 object-cover rounded-xl"
                  />
                )}
              </div>
              <p className="text-sm text-slate-700">{resource.description}</p>
              <div className="flex flex-wrap gap-2 text-xs mt-2">
                <span className="map-filter-pill">📍 {resource.governorate}</span>
                <span className="map-filter-pill">🏷️ {getResourceTypeLabel(resource.type)}</span>
                <span className="map-filter-pill">⭐ {'★'.repeat(resource.importance)}</span>
              </div>
            </div>
          </Popup>
        </Marker>
      ))}
    </ClusterGroup>
  );
};
